/* eslint-disable @typescript-eslint/no-explicit-any */
import * as types from "../../actionTypes/Dashboard/activityActionTypes";

export const postActiviySearchAction = {
  STARTED: (args: any) => ({
    type: types.POST_ACTIVITY_SEARCH.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.POST_ACTIVITY_SEARCH.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.POST_ACTIVITY_SEARCH.REJECTED }),
};

export const getActivitiesListAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVITIES_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITIES_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVITIES_LIST.REJECTED }),
};

export const setCallActivitiesListApi = (payload: boolean) => ({
  type: types.SET_CALL_ACTIVITIES_LIST_API,
  payload,
});

export const getActivityExtraDetailsAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVITY_EXTRA_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITY_EXTRA_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVITY_EXTRA_DETAILS.REJECTED }),
  RESET: () => ({ type: types.RESET_GET_ACTIVITY_EXTRA_DETAILS }),
};

export const setCallActivityExtraDetailsApi = (payload: boolean) => ({
  type: types.SET_CALL_ACTIVITY_EXTRA_DETAILS_API,
  payload,
});

export const getActivityAgeBandAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVITY_AGE_BAND.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITY_AGE_BAND.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVITY_AGE_BAND.REJECTED }),
};

export const getActivityCategoriesAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVITY_CATEGORIES.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITY_CATEGORIES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVITY_CATEGORIES.REJECTED }),
};

export const getActivityAllDetailsAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVITY_ALL_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITY_ALL_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVITY_ALL_DETAILS.REJECTED }),
};

export const setCallActivityAllDetailsApi = (payload: boolean) => ({
  type: types.SET_CALL_ACTIVITY_ALL_DETAILS_API,
  payload,
});

export const getActivityProductInfoAction = {
  STARTED: (args: any) => ({
    type: types.GET_ACTIVITY_PRODUCT_INFO.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_ACTIVITY_PRODUCT_INFO.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_ACTIVITY_PRODUCT_INFO.REJECTED }),
};

export const activityPreBookAction = {
  STARTED: (args: any) => ({
    type: types.ACTIVITY_PRE_BOOK.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ACTIVITY_PRE_BOOK.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.ACTIVITY_PRE_BOOK.REJECTED }),
};

export const activityCheckoutAction = {
  STARTED: (args: any) => ({
    type: types.ACTIVITY_CHECKOUT.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.ACTIVITY_CHECKOUT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.ACTIVITY_CHECKOUT.REJECTED }),
};

export const passportDetailsByBookingIdAction = {
  STARTED: (payload: any) => ({
    type: types.PASSPORT_DETAILS_BY_BOOKINGID.STARTED,
    payload: payload,
  }),
  FULLFILLED: (results: any) => ({
    type: types.PASSPORT_DETAILS_BY_BOOKINGID.FULLFILLED,
    payload: results,
  }),
  REJECTED: (error: any) => ({
    type: types.PASSPORT_DETAILS_BY_BOOKINGID.REJECTED,
    payload: error,
  }),
};
